var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MainLayout',{style:(_vm.style)},[_c('div',{staticClass:"webapp-disabled"},[_c('h1',[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }